import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { LandingPage } from "./pages/landing";
import "react-multi-carousel/lib/styles.css";
import { StoreLocator } from "./pages/store-locator";
import { useEffect } from "react";
import { initializeSegment } from "./utils/segment";
import { trackGaPageView } from "./utils/googleAnalytics";
import { PrivacyPolicyPage } from "./pages/privacy";
import { Recipes } from "./pages/recipes";
import { Products } from "./pages/products";
import { ContactUs } from "./pages/contact-us";
import { Blog } from "./pages/blog";
import { BlogDetail } from "./pages/blog-detail";
import { ChefChallenge } from "./pages/chef-challenge";
import { NewLandingPage } from "./pages/new-landing";
import { ChefChallengeWinners } from "./pages/challenge-winners";
import { CookOffContest } from "./pages/cook-off-contest";

function GaPageViews() {
  const location = useLocation();
  useEffect(() => {
    trackGaPageView(
      `${location.pathname}${location.search}${location.hash}`
    );
  }, [location.pathname, location.search, location.hash]);
  return null;
}

export default function AppRouter() {
  useEffect(() => {
    initializeSegment();
  }, []);

  return (
    <BrowserRouter>
      <GaPageViews />
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/new' element={<NewLandingPage />} />
        <Route path='/where-to-buy' element={<StoreLocator />} />
        <Route path='/privacy-terms' element={<PrivacyPolicyPage />} />
        <Route path='/recipes' element={<Recipes />} />
        <Route path='/contact-us' element={<ContactUs />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/blog/:id' element={<BlogDetail />} />
        <Route path='/products' element={<Products />} />
        <Route path='/cook-off-contest' element={<CookOffContest />} />
        <Route path='/mangrovechefchallenge'>
          <Route index element={<ChefChallenge />} />
          <Route path='winners' element={<ChefChallengeWinners />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
